import "./plan-card.scss";

interface IPlanCardProps {
  label?: string | JSX.Element;
  /** @deprecated Use `label` */
  title?: string;
  value: string | number | JSX.Element;
  subtitle?: string | JSX.Element;
  buttonText?: string;
  secondaryButtonText?: string;
  onClick?: () => void;
  onSecondaryClick?: () => void;
  /** @deprecated Kept for JobSearcherStatistics compat */
  icon?: JSX.Element;
  isLoading?: boolean;
  disabled?: boolean;
}

const baseClassName = "plan-card";

export const PlanCard = ({
  label,
  title,
  value,
  subtitle,
  buttonText,
  secondaryButtonText,
  onClick,
  onSecondaryClick,
  icon,
  isLoading = false,
  disabled = false,
}: IPlanCardProps): JSX.Element => {
  const displayLabel = label || title || "";

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__label`}>{displayLabel}</div>
      <div className={`${baseClassName}__row`}>
        <div className={`${baseClassName}__value`}>
          {isLoading ? (
            <div className={`${baseClassName}__shimmer`} />
          ) : (
            value
          )}
        </div>
        {icon && <span className={`${baseClassName}__icon`}>{icon}</span>}
        <div className={`${baseClassName}__actions`}>
          {secondaryButtonText && (
            <button
              className={`${baseClassName}__action ${baseClassName}__action--secondary`}
              onClick={onSecondaryClick}
            >
              {secondaryButtonText}
            </button>
          )}
          {buttonText && (
            <button
              className={`${baseClassName}__action`}
              onClick={onClick}
              disabled={disabled}
            >
              {buttonText}
            </button>
          )}
        </div>
      </div>
      {subtitle && !isLoading && (
        <div className={`${baseClassName}__subtitle`}>{subtitle}</div>
      )}
    </div>
  );
};
